module.exports = "<select (change)=\"changeLang($event.target.value)\"\n        [(ngModel)]=\"langSelected\">\n  <option [value]=\"lang.lang\" *ngFor=\"let lang of langs | async\">\n    {{lang.label}}\n  </option>\n</select>"


//////////////////
// WEBPACK FOOTER
// ./src/app/control-core/shared/select-lang/select-lang.component.html
// module id = ./src/app/control-core/shared/select-lang/select-lang.component.html
// module chunks = main